import http from "../../http-common";

const update = (data) => http.put("/User/UpdateUserPassword", data);

export default { update };
